import PropTypes from 'prop-types';
import BaseSelectorReadonlyToInput from "../../component/Select/BaseSelectorReadonlyToInput";

class ReadpointMomentReadSelector extends BaseSelectorReadonlyToInput {
  constructor(props) {
    super(props);
    this.state = {
      ...this.state,
      label: 'name',
      title: props.title  || 'Momento da leitura RFID',
      items: [
        {id: 'START_READ', name: 'Início da leitura'},
        {id: 'STOP_READ', name: 'Término da leitura'},
        {id: 'AMBOS', name: 'Ambos'}
      ]
    };
  }
}

ReadpointMomentReadSelector.propTypes = {
  required: PropTypes.bool,
  setValue: PropTypes.func,
  defaultValue: PropTypes.string,
  readonly: PropTypes.bool,
  onChange: PropTypes.func,
};

export default ReadpointMomentReadSelector;



// WEBPACK FOOTER //
// ./src/readpoint/component/ReadpointMomentReadSelector.js